import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import Button from './Button'
import Link from './Link'

import { showModal } from '../../reducers/modal'

import { readCookie } from '../../utils/cookies'
import { createTrackingCookie } from '../../utils/tracking'
import { updateAnalytics, getAnalyticsStatus } from '../../utils/analytics'

import {
  COOKIES_TRACKING_CONSENT_COOKIE_NAME,
  PRIVACY_POLICY_URL
} from '../../config'
import ArrowLink from './ArrowLink'
import CookiesModal from './modals/CookiesModal'

export default connect(
  ({ analytics: { showCookieInfoBar } }) => ({ showCookieInfoBar }),
  { showModal }
)(function CookiesAndAnalyticsInfo ({ showModal, showCookieInfoBar }) {
  const [loading, setLoading] = useState(true)
  const [hasStoredCookie, setHasStoredCookie] = useState(false)

  useEffect(function onMount () {
    const storedCookie = readCookie(COOKIES_TRACKING_CONSENT_COOKIE_NAME)
    setLoading(false)
    setHasStoredCookie(!!storedCookie)
  }, [])

  function handleCloseMessage (analytics) {
    const initialStatus = getAnalyticsStatus()
    createTrackingCookie(analytics)
    updateAnalytics(initialStatus, getAnalyticsStatus())
    setHasStoredCookie(true)
  }

  function handleAcceptAnalytics () {
    handleCloseMessage(true)
  }
  function handleRefuseAnalytics () {
    handleCloseMessage(false)
  }

  if (loading || hasStoredCookie || !showCookieInfoBar) {
    return null
  }

  return (
    <div className='cookies-analytics-info items-start clear-sky-blue p2 fluid-m2 rounded standard-radius'>
      <p className='cookies-analytics-info__text'>
        This website uses cookies to remember your preferences, improve its
        services, facilitate sales activities and communication, and provide ad
        messages relevant to you.&nbsp; For more information, visit our&nbsp;
        <Link
          href={PRIVACY_POLICY_URL}
          target='_blank'
          className='link--underline link--clear-sky-blue'
        >
          Privacy Policy
        </Link>
        .
      </p>
      <div className='cookies-analytics-info__buttons-container md-text-left fluid-mrn3 fluid-mbn2'>
        <ArrowLink
          label='Customize'
          extraClass='fluid-mr3 fluid-mb2'
          onClick={() => {
            showModal(() => <CookiesModal />)
          }}
        />
        <Button
          variation='light'
          extraClass='fluid-mr3 fluid-mb2'
          onClick={handleRefuseAnalytics}
        >
          Decline all
        </Button>
        <Button
          variation='blue'
          onClick={handleAcceptAnalytics}
          extraClass='fluid-mr3 fluid-mb2'
        >
          Accept all
        </Button>
      </div>
    </div>
  )
})
